import JustValidate from 'just-validate';
import axios from 'axios';
import partyModal from './modal';
import stripeProcessing from './stripe-processing';

declare let party_object: any;

// Modal
const modal = new partyModal();

export default class validateForm{

    protected elForm: string;
    protected elFormBtn: string;
    protected elWrapPayment: string;
    protected elBtnStep: string;
    protected elBtnText: string;

    protected modStripeProcessing;

    protected call_rest_api: string;

    constructor(
        elForm: string,
        elFormBtn: string,
        elWrapPayment: string,
        elBtnStep: string,
        elBtnText: string,
        el_form_process: string,
        el_payment_element: string,
        el_loading_payment: string,
        el_payment_response: string,
        el_pay_reinit: string,
        elSpinner: string,
    ){

        this.elForm = elForm;
        this.elFormBtn = elFormBtn;
        this.elWrapPayment = elWrapPayment;
        this.elBtnStep = elBtnStep;
        this.elBtnText = elBtnText;

        this.call_rest_api = party_object.rest_urls.check_data;

        // Stripe
        this.modStripeProcessing = new stripeProcessing(
            elForm,
            el_form_process,
            el_payment_element,
            el_loading_payment,
            el_payment_response,
            el_pay_reinit,
            elFormBtn,
            elSpinner,
            elBtnText
        );

    }

    /**
     * Init
     */
    init(){

        const _that = this;

        this.modStripeProcessing.showForm();

        const validation = new JustValidate('#party-order-form', {
            errorFieldCssClass: 'is-invalid border border-red-300',
            errorLabelCssClass: 'just-validate-error-label flex flex-row flex-wrap basis-full w-full mt-1 !text-red-300',
            focusInvalidField: true,
            lockForm: true,
        });

        validation
        .addField('#field_name', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_surname', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_email', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
            {
                rule: 'email',
                errorMessage: party_object.error_messages.email_invalid,
            },
        ])
        .addField('#field_phone', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_room', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_party_date', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_party_time_start', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])
        .addField('#field_party_time_end', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.field_required,
            },
        ])    
        .addField('#field_privacy_policy', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.check_privacy_policy,
            }
        ])
        .addField('#field_terms_conditions', [
            {
                rule: 'required',
                errorMessage: party_object.error_messages.check_term_condition,
            }
        ])
        .onSuccess((event: any) => {
                
            event.preventDefault();

            _that.dataCheck();
                
        });

    }

    protected dataCheck(){

        const _that = this;

        const wrap_payment = document.querySelector(this.elWrapPayment) as HTMLElement | null;

        const btn_step = document.querySelector(this.elBtnStep) as HTMLButtonElement | null;

        const btn_text = document.querySelector(this.elBtnText) as HTMLButtonElement;

        // Form element
        const form = document.querySelector(this.elForm) as HTMLFormElement;

        // Button element
        const btn = document.querySelector(this.elFormBtn) as HTMLButtonElement | null;

        // Form data
        const data = new FormData(form);

        // Prepare data
        const datastring = new URLSearchParams(data as any).toString();

        // Post data
        const post_data = {
            'fields': datastring
        };

        // Query string
        const queryString = new URLSearchParams(post_data).toString();

        // Init spin
        const spin = this.btnSpin();

        // Set disabled attribute
        btn?.setAttribute('disabled', '');

        // Append spin to button
        btn?.append(spin);

        // Call ajax
        axios.post(this.call_rest_api, queryString, {
            
            validateStatus: function (status) {
                
                return status == 200;
                
            }

        })
        .then(function (response:any){

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

            //  Get status
            const responseStatus:boolean = response.data.status;

            // Append message to body
            document.body?.insertAdjacentHTML('beforeend', response.data.message);

            if(responseStatus == true){         

                wrap_payment?.classList.remove("hidden");
                btn_step?.classList.add("hidden");
                btn_text?.classList.remove("hidden");

                const responseData = response.data.data;

                // Call submit
                _that.modStripeProcessing.handleSubmit(
                    responseData.field_name,
                    responseData.field_surname,
                    responseData.field_email,
                    responseData.field_phone,
                    responseData.phone_full,
                    responseData.phone_country_code,
                    responseData.field_room,
                    responseData.room_name,
                    responseData.field_party_date,
                    responseData.field_party_time_start,
                    responseData.field_party_time_end
                );

            }

        }).catch(function (error: any) {

            //  Get status
            const errorStatus = error.response.status;
                
            if(errorStatus != null && errorStatus == 201){
                
                // Error message
                const errorMessage = error.response.data.message;

                // Append message to body
                document.body?.insertAdjacentHTML('beforeend', errorMessage);

                // Open modal
                modal.get('errorModal', 'closeErrorModal');

            }

            // Remove spin
            spin.remove();
                    
            // Remove the disabled attribute
            btn?.removeAttribute('disabled');

        });

    }

    /**
     * Create spin
     * @returns 
     */
    protected btnSpin(){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', 'bgdrop-spin');
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin ml-1 mt-1');

        return spin;

    }

}